import { ModalHeader, SimpleModal, Space, Typography } from '../..'
// eslint-disable-next-line import/no-unresolved
import { LinkButton } from '../../atoms/buttons/link-button/index'
import {
  StyledDescriptionsContainer,
  StyledLinksContainer
} from './trades-approval-info-modal.styles'

export type TradesApprovalInfoModalProps = {
  onClose: () => void
}

const TradesApprovalInfoModal = ({ onClose }: TradesApprovalInfoModalProps) => {
  const renderLink = (position: number, title: string, linkRef: string) => {
    const onClick = () => {
      const elmntToView = document.getElementById(linkRef)
      elmntToView.scrollIntoView()
    }
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <LinkButton onClick={() => onClick()}>
        {position} .{title}
      </LinkButton>
    )
  }
  const renderSection = (position: number, title: string, description: string, linkRef: string) => (
    <Space id={linkRef}>
      <Typography variant="sh3">
        {position}. {title}
      </Typography>
      <Space pb={4} pt={2}>
        <Typography variant="b3">{description}</Typography>
      </Space>
    </Space>
  )

  return (
    <SimpleModal>
      <ModalHeader onClickClose={() => onClose()}>Trade approval process</ModalHeader>
      <Space p={6}>
        <StyledLinksContainer isflex flexDirection="column">
          <Space p={2}>{renderLink(1, 'Draft', 'draft')}</Space>
          <Space p={2}>{renderLink(2, 'Submitting', 'submitting')}</Space>
          <Space p={2}>{renderLink(3, 'Setting economics', 'setting-economics')}</Space>
          <Space p={2}>{renderLink(4, 'Approving', 'approving')}</Space>
          <Space p={2}>{renderLink(5, 'Committing', 'committing')}</Space>
          <Space p={2}>{renderLink(6, 'Settling', 'settling')}</Space>
          <Space p={2}>{renderLink(7, 'Activating', 'activating')}</Space>
          <Space p={2}>{renderLink(8, 'Activated (live)', 'activated-live')}</Space>
        </StyledLinksContainer>
        <StyledDescriptionsContainer isflex flexDirection="column" mt={6}>
          {renderSection(
            1,
            'Draft',
            'Prior to a trade being submitted, it is saved in a Draft state.  While in this state the trade can be edited further until it is submitted.',
            'draft'
          )}
          {renderSection(
            2,
            'Submitting',
            'Once a trade has been submitted to the approval process, it can no longer be edited by the user.',
            'submitting'
          )}
          {renderSection(
            3,
            'Setting economics',
            'The first step in the approval process is for the Bank to confirm the fees, premiums, clearing provision and funding rates which will be applied to the trade.',
            'setting-economics'
          )}
          {renderSection(
            4,
            'Approving',
            'At this step, the trade will be formally approved or rejected by the Bank.',
            'approving'
          )}
          {renderSection(
            5,
            'Committing',
            'Once the trade has been approved by the Bank, the Client now has 5 business days to formally commit to the trade.',
            'committing'
          )}
          {renderSection(
            6,
            'Settling',
            'If the trade involves new investment being added to the note, then this should be settled once the trade has been committed to.',
            'settling'
          )}
          {renderSection(
            7,
            'Activating',
            'The Bank will then activate the trade, which will trigger the necessary orders and changes to be made on the trade.',
            'activating'
          )}
          {renderSection(
            8,
            'Activated (live)',
            'The trade has now been activated and can be viewed in the Reporting section of the platform.',
            'activated-live'
          )}
        </StyledDescriptionsContainer>
      </Space>
    </SimpleModal>
  )
}

export default TradesApprovalInfoModal
